// React Hooks
import { useEffect, useRef, useState } from "react";

// CSS
import "./operations.css";

// Localisation
import { useTranslation } from "react-i18next";

// components for common panel
import CommonPanel from "../../common/common-panel";
import EmissionOverView from "./common-panel-components/emission-over-view";
import EmissionBySource from "./common-panel-components/emission-by-source";
import AllSurveys from "./common-panel-components/all-surveys-table";
import SelectDaysFilter from "./common-panel-components/select-days-filter";

// Services
import OperationService from "../../../services/AuraCamera/operations.service";
import CustomerService from "../../../services/customer/customer.service";
import Customer from "../../../interfaces/customer/customer";

// Loading Screen
import LoadingScreen from "../../common/Loading";
import PersistantService from "../../../services/autentication/persistant.service";

// Primefaces
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { ConfirmDialog } from "primereact/confirmdialog";

// redux store
import { ReducerTableData } from "../../../store/AuraCamera/operations/operations.store";
import { AppDispatch, AppState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { addCustomersData } from "../../../store/AuraCamera/common";
// Helper
import Helpers from "../../../utils/helpers";

interface Active {
  gridActive?: string;
  tableActive?: string;
}

const Operations = () => {
  document.title = "Dashboard-AURA Camera";

  const CustData_Redux = useSelector(
    (state: AppState) => state.AuraCameraCommon.CustData
  );
  const [custList, custListUpdate] = useState<any>(CustData_Redux);
  const { t } = useTranslation();
  const toast = useRef<any>(null);

  const [CameraList, UpdateCameraList] = useState<any>([]);
  const [SelectedCameraList, UpdateSelectedCameraList] = useState<any>([
    {
      name: "All Cameras",
      id: "all",
    },
  ]);
  const [SortedMapData, UpdateSortedMapData] = useState<any>([]);
  const [MasterSortedMapData, UpdateMasterSortedMapData] = useState<any>([]);
  const dispatch: AppDispatch = useDispatch();
  var ReduxOperationMapData: any = useSelector(
    (state: AppState) => state.Operations.operationMapData
  );
  var ReduxOperationBarGraphData: any = useSelector(
    (state: AppState) => state.Operations.operationBarGraphData
  );
  var ReduxOperationTableData: any = useSelector(
    (state: AppState) => state.Operations.operationTableData
  );

  let customer =
    PersistantService.getPersistSelectedCustomer()?.dashboardSelectedCustomer;

  const [isLoading, isLoadingUpdate] = useState(false);
  const [loadingText, loadingTextUpdate] = useState("");

  const [selectedCustomer, setSelectedCustomer] = useState<any>(CustData_Redux);
  const [FilterSize, setFilterSize] = useState<any>("");
  const [selectedName, setSelectedName] = useState<any>(null);
  const [surveyDate, setSurveyDate] = useState<any>(null);
  const [surveyData, setSurveyData] = useState<any>(null);
  const [filteredValues, setFilteredValues] = useState<any>([]);
  const [OperationTableValues, setOperationTableValues] = useState<any>([]);
  const [MasterOperationTableValues, setMasterOperationTableValues] =
    useState<any>([]);
  const [OperationMapValues, setOperationMapValues] = useState<any>([]);
  const [LeakSizeStateVals, LeakSizeStateValsUpdate] = useState<any>([]);

  const [chosenDay, setChosenDay] = useState<any>("");
  const [chosenDayDateRange, setchosenDayDateRange] = useState<any>("");
  const [displaySelectedDaysLabel, setdisplaySelectedDaysLabel] =
    useState<any>("Last 12 months");
  const [isGrid, layoutToggle] = useState(false);
  const [activeClass, setActiveClass] = useState<Active>({
    gridActive: "",
    tableActive: "icon-active",
  });

  useEffect(() => {
    if (custList == "") {
      setTimeout(()=>{
        CustomerService.getCustomerList().then((res) => {
          dispatch(addCustomersData(res as any));
          custListUpdate(res);
          if (res.length == 1) {
            setSelectedCustomer(res[0]);
          }
        });
      },2500)
      
    } else {
      custListUpdate(custList);
      if (custList.length == 1) {
        setSelectedCustomer(custList[0]);
      }
    }

    // setTimeout(() => {
    //   isLoadingUpdate(false);
    // }, 2000);
  }, []);

  useEffect(() => {
    isLoadingUpdate(true);

    if (true) {
      // Set Date Range
      let EndDate: any = new Date();
      let StartDate: any = new Date();
      const now = new Date();
      let RangeDateSelected = chosenDayDateRange;

      if (RangeDateSelected[0] != null && RangeDateSelected[1] != null) {
        let startD = new Date(chosenDayDateRange[0]);
        let EndD = new Date(chosenDayDateRange[1]);

        StartDate = startD.toISOString();
        EndD.setHours(now.getHours());
        EndD.setMinutes(now.getMinutes());
        EndDate = EndD.toISOString();

        setdisplaySelectedDaysLabel(
          `${Helpers.ConvertUtcToLocalReadable(
            StartDate
          )} - ${Helpers.ConvertUtcToLocalReadable(EndDate)}`
        );
      } else {
        let hours = 365 * 24;
        if (chosenDay == "A") {
          hours = 30 * 24;
          setdisplaySelectedDaysLabel("Last 30 days");
        } else if (chosenDay == "M") {
          hours = 90 * 24;
          setdisplaySelectedDaysLabel("Last 90 days");
        } else if (chosenDay == "P") {
          hours = 365 * 24;
          setdisplaySelectedDaysLabel("Last 12 months");
        }

        StartDate.setHours(StartDate.getHours() - hours);
        StartDate = StartDate.toISOString();
        EndDate = EndDate.toISOString();
      }

      OperationService.OperationTableData(StartDate, EndDate).then(
        (operations_data_res: any) => {
          
          if (operations_data_res == "error") {
            toast?.current?.clear();
            toast?.current?.show({
              severity: "error",
              summary: "Something went wrong",
              detail: "Unable to fetech data, Please try again",
              life: 3000,
            });
            isLoadingUpdate(false);
          } else {
            setSelectedCustomer(custList[0]);

            setOperationTableValues(operations_data_res);
            setMasterOperationTableValues(operations_data_res);
            UpdateSortedMapData(
              Helpers.CreateUniqueArrayOperationTableAPI(operations_data_res)
            );

            // UpdateCameraList
            let temp_camera_list: any = [{ name: "All Cameras", id: "all" }];
            Helpers.CreateUniqueArrayOperationTableAPI(operations_data_res).map(
              (val: any) => {
                let check_flag = 0;
                temp_camera_list?.forEach((val1: any, val2: any) => {
                  if (val1.id == val.cameraID) {
                    check_flag = 1;
                  }
                });
                if (check_flag == 0) {
                  temp_camera_list.push({
                    name: val.cameraName,
                    id: val.cameraID,
                  });
                }
              }
            );
            UpdateCameraList(temp_camera_list);
            UpdateSelectedCameraList({
              name: "All Cameras",
              id: "all",
            });

            UpdateMasterSortedMapData(
              Helpers.CreateUniqueArrayOperationTableAPI(operations_data_res)
            );
            dispatch(ReducerTableData(operations_data_res) as any);
            isLoadingUpdate(false);
          }
        }
      );

      // setTimeout(() => {
      //   isLoadingUpdate(false);
      // }, 2000);
    } else {
      setTimeout(() => {
        isLoadingUpdate(false);
        toast?.current?.clear();
        toast?.current?.show({
          severity: "error",
          summary: "No Data",
          detail: "Please Select Customer",
          life: 3000,
        });
      }, 2000);
    }
  }, [chosenDay, chosenDayDateRange]);

  useEffect(() => {
    // if (surveyData != "") {
    filterValues();
    // }
  }, [selectedName, surveyData]);

  function convert(str: any) {
    var date = new Date(str);

    return [date.getFullYear()].join("-");
  }

  const filterValues = () => {
    let filteredSurveyList = surveyData;
    if (typeof filteredSurveyList == "object") {
      if (selectedName && selectedName.length > 0) {
        filteredSurveyList = filteredSurveyList?.filter((surveyItem: any) => {
          return (
            selectedName.find((statusItem: any) => {
              return (
                surveyItem.name?.toLowerCase() == statusItem.name?.toLowerCase()
              );
            }) != undefined
          );
        });
      } else {
        filteredSurveyList = [];
      }
      setFilteredValues(filteredSurveyList);
    }
  };

  const handleDownload = () => {
    let OperationTableValuesDeepCopy = JSON.parse(
      JSON.stringify(OperationTableValues)
    );
    if (OperationTableValuesDeepCopy?.length > 0) {
      OperationTableValuesDeepCopy?.map((val: any, i: any) => {
        if (val.createdOn != null) {
          val.finalCreatedOn = Helpers.ConvertUtcToLocalReadable(val.createdOn);
        } else {
          val.finalCreatedOn = "";
        }
      });

      Helpers.exportToCSV(
        OperationTableValuesDeepCopy,
        "Survey_Summary",
        "Survey_Summary",
        {
          siteName: "Site name",
          area: "Area",
          operator: "Camera operator",
          finalCreatedOn: "Date",
          totalLeaks: "Leaks Count",
          cameraName: "Camera Name",
        },
        [
          "siteName",
          "area",
          "finalCreatedOn",
          "operator",
          "cameraName",
          "totalLeaks",
        ]
      );
    }
  };

  const handleLayout = (childvalue: any) => {
    layoutToggle(childvalue);
    if (childvalue === true) {
      setActiveClass({
        gridActive: "icon-active",
        tableActive: "",
      });
    } else {
      setActiveClass({
        gridActive: "",
        tableActive: "icon-active",
      });
    }
  };

  const handleSurveyDropDown = (data: any) => {
    UpdateSelectedCameraList({
      name: "All Cameras",
      id: "all",
    });
    let selected_cust_id: any = data.name;

    let filteredTableFromCust: any = MasterSortedMapData?.filter((opr: any) => {
      if (opr?.operator == selected_cust_id) {
        return true;
      }
    });

    let filteredTableFromCustTable: any = MasterOperationTableValues?.filter(
      (opr: any) => {
        if (opr?.operator == selected_cust_id) {
          return true;
        }
      }
    );
    if (selected_cust_id == "All Customers" || selected_cust_id == "" ) {
      filteredTableFromCust = MasterSortedMapData;
      filteredTableFromCustTable = MasterOperationTableValues;
    }
    // UpdateCameraList
    let temp_camera_list: any = [
      {
        name: "All Cameras",
        id: "all",
      },
    ];
    filteredTableFromCustTable.map((val: any) => {
      let check_flag = 0;
      temp_camera_list?.forEach((val1: any) => {
        if (val1.id == val.cameraID) {
          check_flag = 1;
        }
      });
      if (check_flag == 0) {
        temp_camera_list.push({ name: val.cameraName, id: val.cameraID });
      }
    });
    UpdateCameraList(temp_camera_list);
    setOperationTableValues(filteredTableFromCustTable);

    UpdateSortedMapData(filteredTableFromCust);
    setSelectedCustomer(data);
    PersistantService.setPersistSelectedCustomer({
      surveySelectedcustomer: data,
    });
  };

  const handleCameraDropdown = (data: any) => {
    UpdateSelectedCameraList(data);
    
    let camera_id: any = data.id;
    let selectedCust = selectedCustomer?.name;
    // opr?.customerID == selectedCust || opr?.customerID == ''
    let filteredTableFromCust: any = MasterSortedMapData?.filter((opr: any) => {
      // if both all selected
      if (
        camera_id == "all" &&
        (selectedCust == "" || selectedCust == undefined)
      ) {
        return true;
      }

    
      if (
        camera_id == "all" &&
        (selectedCust != "" || selectedCust != undefined)
      ) {
        if (opr?.operator == selectedCust) {
          return true;
        }
      }

      // if customer all and selcted camera

      if (
        (selectedCust == "" || selectedCust == undefined) &&
        camera_id != "all"
      ) {
        if (opr?.cameraID == camera_id) {
          return true;
        }
      }
      // if both have values
      if (
        selectedCust != "" &&
        selectedCust != undefined &&
        camera_id != "all"
      ) {
        if (opr?.cameraID == camera_id && opr?.operator == selectedCust) {
          return true;
        }
      }
    });

    let filteredTableFromCustTable: any = MasterOperationTableValues?.filter(
      (opr: any) => {
        // if both all selected
        if (
          camera_id == "all" &&
          (selectedCust == "" || selectedCust == undefined)
        ) {
          return true;
        }

        // if camera all selected with having customer
        if (
          camera_id == "all" &&
          (selectedCust != "" || selectedCust != undefined)
        ) {
          if (opr?.operator == selectedCust) {
            return true;
          }
        }

        // if customer all and selcted camera

        if (
          (selectedCust == "" || selectedCust == undefined) &&
          camera_id != "all"
        ) {
          if (opr?.cameraID == camera_id) {
            return true;
          }
        }
        // if both have values
        if (
          selectedCust != "" &&
          selectedCust != undefined &&
          camera_id != "all"
        ) {
          if (opr?.cameraID == camera_id && opr?.operator == selectedCust) {
            return true;
          }
        }
      }
    );
    setOperationTableValues(filteredTableFromCustTable);

    UpdateSortedMapData(filteredTableFromCust);
  };
  return (
    <>
      <Toast ref={toast} style={{ marginTop: "25px" }} />
      <LoadingScreen isLoading={isLoading} text={loadingText} />
      {/* <ConfirmDialog /> */}
      <nav aria-label="breadcrumb" className="breadcrumb--wrapper">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>{t("Operations")}</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            <a>Dashboard-aura camera</a>
          </li>
        </ol>
      </nav>
      <div className="content__header">
        <div className="content__wrap">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <h4 className="page-heading">Dashboard-AURA Camera</h4>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div className="banner-feilds--block">
                <div className="field-col-left">
                  <div className="dropcol1">
                    <Dropdown
                      className="surveyDropdown"
                      value={selectedCustomer}
                      options={custList}
                      onChange={(e: any) => {
                        handleSurveyDropDown(e.target.value);
                      }}
                      optionLabel="name"
                      filter
                      filterBy="name"
                      placeholder={`${t("Survey.IndexCustomer")}`}
                    />
                  </div>
                  <div className="dropcol2">
                    <Dropdown
                      className="surveyDropdown"
                      value={SelectedCameraList}
                      options={CameraList}
                      onChange={(e: any) => {
                        handleCameraDropdown(e.target.value);
                        // handleSurveyDropDown(e.target.value);
                      }}
                      optionLabel="name"
                      filter
                      filterBy="name"
                      placeholder={"Camera"}
                    />
                  </div>
                </div>
                <div className="field-col-right">
                  <div className="" id="divCustFilter">
                    <div className="align-items-end">
                      <div className="bannerfilter" style={{ right: 0 }}>
                        {/*  <div className="filterBySize">
                      <label style={{ marginRight: "5px" }}>
                        Filter by Size
                      </label>

                      <MultiSelect
                        showSelectAll={false}
                        style={{
                          fontSize: "12px",
                          width: "100%",
                          borderRadius: "4px",
                        }}
                        className={"basic-single"}
                        maxSelectedLabels={3}
                        placeholder={`Select Size`}
                        selectedItemsLabel={`${operatorsSelectedLabels}`}
                        id="source"
                        name="source"
                        value={FilterSizeSelectedVal}
                        options={FilterSizeVal}
                        optionLabel="name"
                        onChange={(e) => {
                          setFilterSizeSelectedVal(e?.value);
                        }}
                      />
                    </div> */}
                        <div className="timelineBlock">
                          <div className="inner">
                            <label>{displaySelectedDaysLabel}</label>
                            <div className="timelinePop">
                              <SelectDaysFilter
                                setChosenDay={setChosenDay}
                                chosenDay={chosenDay}
                                setchosenDayDateRange={setchosenDayDateRange}
                                chosenDayDateRange={chosenDayDateRange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content__boxed dashboard_aogi_content_box_first">
        <div className="content__wrap">
          <div className="dashboard_main_grid_div">
            <div className="card emission-overview-map">
              <CommonPanel
                InnerComponent={
                  <EmissionOverView SortedMapData={SortedMapData} />
                }
                Heading="Inspection Overview"
              />
            </div>
            <br className="d-md-none" />
            <div className="card emission-by-source">
              <CommonPanel
                InnerComponent={
                  <EmissionBySource SortedBarGraph={SortedMapData} />
                }
                Heading="Max leak"
              />
            </div>
            <br className="d-md-none" />
            <br className="d-md-none" />
            <br className="d-md-none" />
            {/* <button onClick={handleClearSearch}>clear</button> */}
            <div className="card all-surveys-table">
              <CommonPanel
                tableData={handleLayout}
                gridData={handleLayout}
                activeClass={activeClass}
                downloadData={handleDownload}
                InnerComponent={
                  <AllSurveys
                    isGrid={isGrid}
                    filteredValues={OperationTableValues}
                  />
                }
                Heading={`${t("All Survey")}`}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Operations;
